import { useState } from 'react';
// @ts-ignore
import AddUser from '../components/Admin/AddUser';
import AddPayment from '../components/Admin/AddPaymentDetails';
import ResetPassword from '../components/Admin/ResetPassword';
import UploadUserLogo from '../components/Admin/UploadLogo';
import EditUser from '../components/Admin/EditUserDetails';
import Dashboard from '../components/Admin/Dashboard';
import EditUserWhatsapp from "../components/Admin/EditUserWhatsApp";
import { collection, getDocs } from "firebase/firestore";
//@ts-ignore
import {db} from '../utils/firebase';
import UploadMenu from '../components/Admin/UploadMenu';
//@ts-ignore
import {useAuth} from '../state/AuthContext';
import { useNavigate } from 'react-router-dom';
//@ts-ignore
import DeleteOrders from './DeleteOrders'


const Admin = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [currentPage, setCurrentPage] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [businessData, setBusinessData] = useState<any>([]);
  // Mock data stored in useState
  const { logout } = useAuth();
  const navigate = useNavigate();



  const [business, setBusiness] = useState({
    Data: [
      // Add 100 mock entries for demonstration
      ...Array.from({ length: 100 }, (_, i) => ({
        id: i + 1,
        name: `Matin Business`,
        // menuViews: Math.floor(Math.random() * 10000),
        menuViews: 0,
        lastPaymentDate: '10-01-2025',
        nextPaymentDate: '10-02-2025',
        lastPaymentAmount: '₹50000',
        nextPaymentAmount: '₹50000',
        status: i % 2 === 0 ? 'Active' : 'Inactive',
      })),
    ],
  });


  const fetchData = async () => {
    setLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "userDetails")); // Firestore collection
      const businessArray = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBusinessData(businessArray);
      //console.log("fetch press", businessArray)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };


  // Pagination logic
  const itemsPerPage = 10;
  // const totalPages = Math.ceil(business.Data.length / itemsPerPage);

  // // Get current page data
  // const currentData = business.Data.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  // Handle page change
  // const handlePageChange = (newPage : number) => {
  //   if (newPage >= 1 && newPage <= totalPages) {
  //     setCurrentPage(newPage);
  //   }
  // };
   // Pagination logic
   const totalPages = Math.ceil(businessData.length / itemsPerPage);
   const currentData = businessData.slice(
     (currentPage - 1) * itemsPerPage,
     currentPage * itemsPerPage
   );
 
   // Handle page change
   const handlePageChange = (newPage : number) => {
     if (newPage >= 1 && newPage <= totalPages) {
       setCurrentPage(newPage);
     }
   };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Mobile Header */}
      <div className="lg:hidden bg-white shadow p-4 flex justify-between items-center">
        <button onClick={() => setIsSidebarOpen(!isSidebarOpen)} className="text-blue-600 focus:outline-none">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
        
        <div className="text-xl font-bold text-[#0b3a28]">Admin Dashboard</div> 
      </div>

      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 w-64 bg-white shadow-lg transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0 transition-transform duration-200 ease-in-out z-30`}
      >
        <div className="p-4 text-2xl font-bold text-[#0b3a28]  hidden lg:block">Admin Dashboard</div>
        <nav className="mt-4">
          {[
            ['dashboard', 'Dashboard'],
            ['addUser', 'Add User'],
            ['addPayment', 'Add Payment'],
            ['resetPassword', 'Reset Password'],
            ['uploadLogo', 'Upload Logo'],
            ['editUser', 'Edit User'],
            ['uploadMenu', 'Upload Menu'],
            ['EditUserWhatsapp', 'Edit Whatsapp No'],
            ['DeleteRecord', 'Delete Orders'],
            ['logout', 'Logout'],
          ].map(([tab, name]) => (
            <button
              key={tab}
              onClick={() => {
                if(tab === 'logout'){
                  logout(navigate);
                  return;
                }
                setActiveTab(tab);
                setIsSidebarOpen(false);
              }}
              className={`w-full px-6 py-3 text-left hover:bg-blue-50 ${
                activeTab === tab ? 'bg-blue-50 text-[#0b3a28] border-r-4 text-[#0b3a28]' : ''
              }`}
            >
              {name}
            </button>
          ))}
        </nav>
      </div>

      {/* Overlay for mobile sidebar */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Main Content */}
      <div className="lg:ml-64 p-4 lg:p-8">
        {activeTab === 'dashboard' && <Dashboard currentData={currentData} currentPage ={currentPage} handlePageChange={handlePageChange} totalPages={totalPages} onFetchPress = {fetchData}/> }

        {activeTab === 'addUser' && <AddUser />}
        {activeTab === 'addPayment' && <AddPayment />}
        {activeTab === 'resetPassword' && <ResetPassword />}
        {activeTab === 'uploadLogo' && <UploadUserLogo />}
        {activeTab === 'editUser' && <EditUser />}
        {activeTab === 'uploadMenu' && <UploadMenu />}
        {activeTab === 'EditUserWhatsapp' && <EditUserWhatsapp />}
        {activeTab === 'DeleteRecord' && <DeleteOrders />}
       
      </div>
    </div>
  );
};

export default Admin;